import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Circles } from 'react-loading-icons';
import Review from './Review';
import { SERVER_URL } from '../../util/EnvironmentConfig';
import axios from 'axios';

const ProgressBar = ({ label, value, max }) => {
  return (
    <div className="w-full mb-4">
      <div className="flex justify-between text-sm font-semibold mb-1 text-white">
        <span>{label}</span>
        <span>{Math.round((value / max) * 100)}%</span>
      </div>
      <div className="w-full bg-gray-700 rounded-full h-3">
        <div
          className="bg-secondary h-3 rounded-full"
          style={{ width: `${(value / max) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const server_url = process.env.REACT_APP_API_URI;
  const token = localStorage.getItem('loginToken');
  const [userData, setUserData] = useState(null);
  const [userPoints, setUserPoints] = useState(null);
  const [pointHistory, setPointHistory] = useState([]);
  const [badgeProgress, setBadgeProgress] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData(decoded);
      } catch (error) {
        console.error('Invalid token:', error);
        setUserData(null);
      }
    }
  }, [token]);

  useEffect(() => {
    if (!userData || !userData.id) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        const [pointsRes, historyRes, badgesRes] = await Promise.all([
          axios.post(`${server_url}/user/points-balance`, {
            userId: userData.id,
          }),
          axios.post(`${server_url}/user/points-balance-history`, {
            userId: userData.id,
          }),
          axios.post(`${SERVER_URL}/user/badges`, { userId: userData.id }),
        ]);
        setUserPoints(pointsRes.data.points);
        setPointHistory(historyRes.data.pointsHistory || []);
        setBadgeProgress(badgesRes.data || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false);
    };
    fetchData();
  }, [userData, server_url]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-white">
        <Circles />
      </div>
    );
  }

  return (
    <div className="px-6 md:px-10 lg:px-20 py-8 max-w-screen-2xl mx-auto text-white">
      <h1 className="text-3xl font-bold text-center mb-6">Dashboard</h1>

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="w-full lg:w-3/4 h-fit lg:p-6 p-4 bg-white/10 rounded-lg">
          <div className="p-4 flex justify-between items-center bg-gray-900 rounded-lg mb-4">
            <h2 className="text-lg font-bold">
              Total Points: <span className="text-green-400">{userPoints}</span>
            </h2>
            <button
              className="bg-secondary px-3 py-2 rounded-md font-bold"
              onClick={() => (window.location.href = '/marketplace')}
            >
              Redeem Points
            </button>
          </div>

          <div className="bg-gray-900 p-3 rounded-lg mb-5">
            <h3 className="font-bold text-xl mb-3 text-center">
              Point History
            </h3>
            <ul>
              {pointHistory.length > 0 ? (
                pointHistory
                  .sort((a, b) => b.timestamp - a.timestamp)
                  .slice(0, 5)
                  .map((x, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center border-b border-gray-700 py-3"
                    >
                      <span className="font-semibold">{x.activity}</span>
                      <span>{new Date(x.timestamp).toLocaleDateString()}</span>
                      <span
                        className={
                          x.points >= 0
                            ? 'text-green-400 font-bold'
                            : 'text-red-500 font-bold'
                        }
                      >
                        {x.points >= 0 ? `+${x.points} pts` : `${x.points} pts`}
                      </span>
                    </li>
                  ))
              ) : (
                <li className="text-center text-gray-400 py-3">
                  No recorded history
                </li>
              )}
            </ul>
          </div>

          <div className="bg-gray-900 p-3 rounded-lg ">
            <h3 className="font-bold text-xl mb-3 text-center">
              Family Badge Progress
            </h3>
            {badgeProgress.map((badge, index) => (
              <ProgressBar
                key={index}
                label={badge.name}
                value={badge.progress}
                max={100}
              />
            ))}
          </div>
        </div>

        <div className="w-full lg:w-1/4 bg-white/10 lg:p-6 p-4 rounded-lg shadow-lg">
          <Review />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
